import styles from './Br.module.css';

export function NonMobileBr() {
  return <br className={styles.nonMobileBr} />;
}

export function MobileBr() {
  return <br className={styles.mobileBr} />;
}
